import { RouterIcon } from 'lucide-react';

/**
 * The hub a group of samples hangs off, as the field view shows it: just the
 * root node of their tree, a marker that they share a device. Its identity,
 * health and settings are ours to watch, not the project's, and live in the
 * backoffice hub card.
 */
export default function Hub() {
    return (
        <div className="h-10 w-10 rounded-md bg-[#e8efe9] border border-[#cdd0c7] flex items-center justify-center">
            <RouterIcon className="h-5 w-5 text-[#2d6a4f]" />
        </div>
    );
}
